import { render, staticRenderFns } from "./equipment-list.vue?vue&type=template&id=2239a8bb"
import script from "./equipment-list.vue?vue&type=script&lang=js"
export * from "./equipment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports